module.exports = __webpack_public_path__ + "img/bianyaqi.a7c5ec50.png";